import { render, staticRenderFns } from "./blockquote.vue?vue&type=template&id=24dd5eaf&"
import script from "./blockquote.vue?vue&type=script&lang=js&"
export * from "./blockquote.vue?vue&type=script&lang=js&"
import style0 from "./blockquote.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24dd5eaf')) {
      api.createRecord('24dd5eaf', component.options)
    } else {
      api.reload('24dd5eaf', component.options)
    }
    module.hot.accept("./blockquote.vue?vue&type=template&id=24dd5eaf&", function () {
      api.rerender('24dd5eaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blockquote/blockquote.vue"
export default component.exports